/*©**********************************************************************************
*                                                                                   *
* SPDX-License-Identifier: AGPL-3.0-or-later                                        *
*                                                                                   *
* This program is licensed under the GNU Affero General Public License v3+.         *
* See the LICENSE file or <https://www.gnu.org/licenses/agpl-3.0.html> for details. *
*                                                                                   *
**********************************************************************************©*/

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const location = useLocation();

  let isAdmin = false;
  if (typeof window !== 'undefined') {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        const raw = user?.is_admin ?? user?.isAdmin;
        isAdmin = raw === true || raw === 1;
      } catch (error) {
        console.error('Error parsing user info for admin check:', error);
      }
    }
  }

  if (!isAdmin) {
    // Non-admins are redirected to the main dashboard
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Ensure the user is authenticated (token present & valid) via ProtectedRoute
  return <ProtectedRoute>{children}</ProtectedRoute>;
};

export default AdminRoute;

